module.exports = __webpack_public_path__ + "static/media/python-logo.b32ab39f.png";